import Analytics, { AnalyticsInstance } from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const measurementId: string = process.env.REACT_APP_GA_MEASUREMENT_ID || ''

let analyticsInstance: AnalyticsInstance | null = null

const analyticsLib = {
  init(): void {
    if (measurementId && !analyticsInstance) {
      analyticsInstance = Analytics({
        app: 'customer-portal-web',
        plugins: [
          googleAnalytics({
            measurementIds: [measurementId],
          }),
        ],
      })
    }
  },

  page(...args: Parameters<AnalyticsInstance['page']>): void {
    if (analyticsInstance) {
      analyticsInstance.page(...args).catch((error) => {
        console.error('Error calling analytics.page:', error)
      })
    }
  },

  track(...args: Parameters<AnalyticsInstance['track']>): void {
    if (analyticsInstance) {
      analyticsInstance.track(...args).catch((error) => {
        console.error('Error calling analytics.track:', error)
      })
    }
  },
}

export default analyticsLib
